import React from 'react'
import { withStyleSheetOverride } from '@klarna/higher-order-components'

import {
  TitlePrimary,
  ParagraphSecondary
} from 'mage-deps/@klarna/bubble-ui'
import { Message } from 'mage-i18n'
import PropTypes from 'prop-types'
import Lock from './Lock'

const getDefaultStyleSheet = () => ({
  iconContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    margin: '80px 0 40px'
  }
})

const AccessDenied = ({ styleSheet }) => {
  return (
    <div>
      <div style={styleSheet.iconContainer}>
        <Lock />
      </div>
      <TitlePrimary centered>
        <Message path='core.accessDenied.title' />
      </TitlePrimary>
      <ParagraphSecondary centered>
        <Message path='core.accessDenied.message' />
      </ParagraphSecondary>
    </div>
  )
}

AccessDenied.propTypes = {
  styleSheet: PropTypes.shape({
    iconContainer: PropTypes.object
  })
}

export default withStyleSheetOverride(
  getDefaultStyleSheet
)(AccessDenied)

export {
  AccessDenied
}
